export const ZOOM_LEVELS = {
  SMALL: 10,
  MEDIUM: 12,
  LARGE: 14,
} as const;

interface MarkerSizes {
  container: string;
  icon: number;
  fontSize: string;
  statusIndicator: string;
  border: string;
}

export function getMarkerSizesByZoom(zoomLevel: number): MarkerSizes {
  if (zoomLevel < ZOOM_LEVELS.MEDIUM) {
    return {
      container: "w-2 h-2",
      icon: 0, // No icon at this size
      fontSize: "text-[0px]",
      statusIndicator: "w-2 h-2",
      border: "border",
    };
  }

  if (zoomLevel < ZOOM_LEVELS.LARGE) {
    return {
      container: "w-6 h-6",
      icon: 16,
      fontSize: "text-[10px]",
      statusIndicator: "w-2.5 h-2.5",
      border: "border-2",
    };
  }

  return {
    container: "w-10 h-10",
    icon: 24,
    fontSize: "text-[14px]",
    statusIndicator: "w-3 h-3",
    border: "border-2",
  };
}

export function shouldShowTooltip(zoomLevel: number): boolean {
  return zoomLevel >= ZOOM_LEVELS.MEDIUM;
}

export function shouldShowIcon(zoomLevel: number): boolean {
  return zoomLevel >= ZOOM_LEVELS.MEDIUM;
}

export function shouldShowStatus(zoomLevel: number): boolean {
  return zoomLevel >= ZOOM_LEVELS.MEDIUM;
}
